import './App.css';
import React, { useState } from 'react';
import CustomButton from './Components/Buttons';
import { useNavigate } from 'react-router-dom'; 
import { useTranslation, Trans } from 'react-i18next';


function StartPage() {
    const navigate = useNavigate(); // Get the navigate function
    const {t} =useTranslation();
    const [width, setWidth] = useState(window.innerWidth);
    window.addEventListener('resize', () => setWidth(window.innerWidth));
  console.log(width);
    return (
      <>
      <main>
        <img 
          src={`${process.env.PUBLIC_URL}/AppIcon.png`} 
          alt="App Icon" 
          className="app-icon"
          style={{/*marginTop: '100px'*/}}
        />
  <p style={{textAlign: 'justify', marginTop: '5px', marginLeft: width>1200 ? width/8 : width/8, marginRight: width>1200 ? width/8 : width/8, fontFamily: 'KomikaAxis', fontSize: '16px', color: 'var(--primary-color)'}}>
    {t('profileDescription')}
 </p>
  
        <CustomButton
          label= {t('buttonStart')}
          type="secondary"
          onClick={() => navigate('/surveyprofile')} 
          style={{ marginTop: '20px' }} 
  
        />
      </main>
      </>
    );
  }

  export default StartPage;